import { useTranslation } from 'next-i18next'

import CheckmarkCircleIcon from '~/components/Icons/svgs/CheckmarkCircleIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import { Link } from '~/components/Link'

export default function DrillTopicListElement({
  gridClassNames,
  image,
  imageClassNames,
  title,
  completed,
  path,
}: {
  completed: boolean
  gridClassNames: string
  image: string
  imageClassNames: string
  title: string
  path: string
}): React.ReactElement {
  const { t } = useTranslation('generics')
  const label = title === 'Brok' ? 'Brøk' : title
  const ariaLabel = `${t('goTo')} ${label}`
  const href = `/drill/${path}`

  const sizeCx = 'w-[226px] h-[235px] xl:w-[234px] xl:h-[252px]'

  return (
    <div
      className={`-mx-2 -my-7 xl:-my-8 transform pointer-events-none hover:scale-105 transition ${gridClassNames} ${sizeCx}`}
    >
      <Background ariaLabel={ariaLabel} className={`absolute pointer filter drop-shadow-lg ${sizeCx}`} link={href} />
      <div className="h-full pt-14 pb-10 px-8 xl:pt-16 xl:pb-10 flex flex-col items-center">
        {completed && (
          <div className="z-20 scale-[0.8] absolute left-1/2 top-3 transform -translate-x-1/2 md:top-6 md:scale-100">
            <SVGIcon icon={CheckmarkCircleIcon} pathClassName="text-green" size={30} />
          </div>
        )}
        <div className="z-20 text-xxs text-hotpink text-center font-semibold leading-none xl:text-xs">{label}</div>
        <img alt={label} className={`z-20 my-auto ${imageClassNames}`} src={image} />
        <button className="z-20 mb-1 px-3 py-1.5 rounded font-semibold bg-orange-light ">{t('go')}</button>
      </div>
    </div>
  )
}

function Background({
  className,
  link,
  ariaLabel,
}: {
  className: string
  link: string
  ariaLabel: string
}): React.ReactElement {
  return (
    <svg className={className} fill="none" viewBox="0 0 252 266" xmlns="http://www.w3.org/2000/svg">
      <g>
        <Link aria-label={ariaLabel} className="pointer-events-auto cursor-pointer" to={link}>
          <path
            d="M116 8.7735C122.188 5.20085 129.812 5.20085 136 8.7735L225.119 60.2265C231.307 63.7992 235.119 70.4017 235.119 77.547V180.453C235.119 187.598 231.307 194.201 225.119 197.774L136 249.226C129.812 252.799 122.188 252.799 116 249.226L26.8808 197.774C20.6928 194.201 16.8808 187.598 16.8808 180.453V77.547C16.8808 70.4017 20.6928 63.7992 26.8808 60.2265L116 8.7735Z"
            fill="white"
          />
        </Link>
      </g>
    </svg>
  )
}
